
















































































































































































































import Vue from 'vue'
import VideoPlayer from '@/components/product/VideoPlayer.vue'
import Category from '@/models/Category'
import NeueCategoryPostTree from '@/components/common/NeueCategoryPostTree.vue'
import InstructorCard from '@/components/product/InstructorCard.vue'
import { findNextPostId } from '@/helper'
import CategoryTreeNode, {
  CategoryTreeNodeType
} from '@/models/CategoryTreeNode'
import CommentList from '@/components/comments/CommentList.vue'
import { MAXIMUM_CHARACTER_LENGTH_BEFORE_READMORE } from '@/helper/constants'
import { showCollapsableDescription } from '@/helper'
import QuizStatusComponent from '@/components/assessments/QuizStatusComponent.vue'

export default Vue.extend({
  components: {
    VideoPlayer,
    NeueCategoryPostTree,
    InstructorCard,
    CommentList,
    QuizStatusComponent
  },
  props: {
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    activePost: {
      type: Object
    },
    category: {
      type: Object
    },
    videoOptions: {
      type: Object
    },
    playlist: {
      type: Array
    },
    disableActions: {
      type: Object
    },
    nextPost: {
      type: Object
    },
    totalPosts: {
      type: Number,
      default: 0
    },
    completedPosts: {
      type: Number,
      default: 0
    },
    postCompletionButtonText: String,
    postMarkedAsCompleted: Boolean,
    lessonButton: Object,
    isAdmin: Boolean,
    categoryTree: Array,
    fetchingPost: Boolean,
    fetchingPostCompletionStatus: Boolean,
    disablePostCompletionButton: Boolean,
    completedPostIds: {
      type: Set,
      default: new Set()
    }
  },
  created() {
    this.$bus.$on('updateActiveCategory', this.updateActiveCategory)
  },
  beforeDestroy() {
    this.$bus.$off('updateActiveCategory', this.updateActiveCategory)
  },
  metaInfo() {
    const meta = {}
    meta['link'] = [
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css?family=Lato',
        vmid: 'newYorkFonts'
      }
    ]
    return meta
  },
  mounted() {
    document
      .querySelector('#read-more-post')
      ?.addEventListener('click', this.expandPostDescription)
    this.createActiveCategory(this.categoryTree)
  },
  computed: {
    productId(): string {
      return this.$route.params.id
    },
    categoryId(): string {
      return this.$route.params.category_id
    },
    postId(): string {
      return this.$route.params.post_id
    },
    themeSettings(): object {
      return this.product.customizations?.lessonSettings?.themeSettings
    },
    sections(): object {
      return this.product.customizations?.lessonSettings?.sections
    },
    postCompletedIcon(): string {
      if (this.sections?.lessonBody?.button?.color) {
        return this.sections?.lessonBody?.button?.color
      } else if (
        this.themeSettings?.primaryStyle?.color &&
        !this.completedPostIds.has(this.postId)
      ) {
        return this.themeSettings?.primaryStyle.color
      }
      return this.postMarkedAsCompleted
        ? '#2f855a'
        : this.disablePostCompletionButton || this.isAdmin
        ? '#6b7280'
        : '#ffffff'
    },
    markCompletedBtnCss(): string {
      if (this.disablePostCompletionButton || this.isAdmin) {
        return 'lessonPrimaryStyle lesson-body__btn bg-white text-gray-600 cursor-not-allowed'
      } else if (this.postMarkedAsCompleted) {
        return 'text-green-700'
      }
      return 'bg-nova-blue-800 text-white lessonPrimaryStyle lesson-body__btn'
    },
    availableCategoryTree(): object {
      return this.categoryTree.filter((node: any) => node.node.available)
    },
    availablePlayList(): Array<CategoryTreeNode> {
      return this.playlist.filter(
        (node: any) =>
          node.type === CategoryTreeNodeType.Post ||
          (node.type === CategoryTreeNodeType.Category && node.node.available)
      )
    },
    nextPostData(): object {
      return findNextPostId(
        this.availableCategoryTree,
        this.postId,
        this.category,
        this.availablePlayList
      )
    },
    postIndexes(): Map<string, number> {
      const postIndexes = new Map()
      for (let i = 0; i < this.categoryTree.length; i++) {
        let index = 1
        this.categoryTree[i]?.childs?.forEach((node: CategoryTreeNode) => {
          if (node.type === CategoryTreeNodeType.Post) {
            postIndexes.set(node.id, index++)
          } else {
            for (let i = 0; i < node.childs.length; i++) {
              postIndexes.set(node.childs[i].id, index++)
            }
          }
        })
      }
      return postIndexes
    },
    postDescription(): string {
      return this.activePost.description &&
        this.activePost.description.length >
          MAXIMUM_CHARACTER_LENGTH_BEFORE_READMORE
        ? this.derivePostDescription() +
            '.... ' +
            `<span class="text-blue-500 cursor-pointer" id="read-more-post">Read More</span>`
        : this.activePost.description
    },
    isExpandable(): boolean {
      return this.activePost?.description?.length > 5700 ? true : false
    },
    navigationButtonColor(): string {
      if (this.sections?.lessonBody?.navigationButton?.color) {
        return this.sections.lessonBody.navigationButton.color
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle.color
      }
      return '#3B5998'
    },
    highlightBackground(): string {
      if (this.sections?.courseNavigation?.highlight?.backgroundColor) {
        return this.sections?.courseNavigation?.highlight?.backgroundColor
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle?.color
      }
      return '#709be0'
    },
    highlightColor(): string {
      if (this.sections?.courseNavigation?.highlight?.color) {
        return this.sections.courseNavigation.highlight.color
      } else if (this.themeSettings?.secondaryStyle?.color) {
        return this.themeSettings?.secondaryStyle?.color
      }
      return '#ffffff'
    },
    percentCompleted(): number {
      if (this.completedPosts && this.totalPosts) {
        return Math.round((this.completedPosts * 100) / this.totalPosts)
      }

      return 0
    }
  },
  data() {
    return {
      parentCategory: null as Category,
      expandPost: false,
      readMorePost: null,
      showExpandIcon: false,
      expandPostData: false,
      post: {},
      toggleCategory: {},
      canRetakeQuiz: false
    }
  },
  methods: {
    changeQuizStatus(quizRetake: boolean) {
      this.canRetakeQuiz = quizRetake
    },
    goToNextPost() {
      this.$router.push({
        name: 'post-overview',
        params: {
          id: this.productId,
          category_id: this.nextPostData.categoryId,
          post_id: this.nextPostData.postId
        },
        query: {
          template_id: this.templateId
        }
      })
    },
    expandPostDescription() {
      if (!this.expandPost) {
        document
          .querySelector('#read-more-post')
          .removeEventListener('click', this.expandPostDescription)
      }
      this.expandPost = !this.expandPost
      if (!this.expandPost) {
        setTimeout(() => {
          document
            .querySelector('#read-more-post')
            .addEventListener('click', this.expandPostDescription)
        }, 500)
      }
    },
    updateActiveCategory(categoryId: string) {
      this.toggleCategory[categoryId] = !this.toggleCategory[categoryId]
    },
    derivePostDescription(): string {
      return showCollapsableDescription(this.activePost)
    },
    expandPostDetails() {
      this.expandPostData = !this.expandPostData
    },
    togglePostCompletion() {
      this.$emit('togglePostCompletion')
    },
    createActiveCategory(categoryTree) {
      const obj = {}
      for (let i = 0; i < categoryTree.length; i++) {
        obj[categoryTree[i].id] = true
      }
      this.toggleCategory = { ...obj }
    }
  },
  watch: {
    categoryTree: {
      handler(value) {
        this.createActiveCategory(value)
      }
    }
  }
})
